const Style = {
  onboarding: 'flex items-center justify-center min-h-full text-left bg-[var(--theme-bg-color)] backdrop-blur-[20px]',
};

export default Style;
